import { Select } from "antd";

const CSelect = (props) => {
  const { placeholder, children, showSearch = true, ...rest } = props;
  const opts = showSearch
    ? {
        showSearch,
        optionFilterProp: "children",
        filterOption: (input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,
      }
    : { showSearch: false };
  return (
    <Select
      placeholder={placeholder || "--Select--"}
      {...rest}
      allowClear={true}
      {...opts}
    >
      {children}
    </Select>
  );
};
export default CSelect;
